import getConfig from '~/config';
import { mapboxGlyphs } from '../common';

const config = getConfig();

const url = `https://basemapstyles-api.arcgis.com/arcgis/rest/services/styles/v2/styles/arcgis/imagery/standard?type=style&token=${config.esriToken}`;

export async function bootstrap() {
  return await fetch(url)
    .then((res) => res.json())
    .then((data) => {
      data.glyphs = mapboxGlyphs;
      data['name'] = 'Satellite (ESRI)';
      return data;
    })
    .catch((err) => {
      console.error('Error bootstrapping ESRI ArcGIS basemap: ', err);
      return undefined;
    });
}
